module.exports = __webpack_public_path__ + "img/DeliverDrug2.7927bc86.svg";